import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import BuilderPage from "@/pages/BuilderPage";
import SuccessPage from "@/pages/SuccessPage";
import ShareCVPage from "@/pages/ShareCVPage";
import AdminPage from "@/pages/AdminPage";
import RefundPolicyPage from "@/pages/RefundPolicyPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/builder" element={<BuilderPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/cv/share/:shareToken" element={<ShareCVPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
